import { useCallback, useEffect, useState } from 'react';
import { billingApi } from '../services/api/billingApi';
import { useRenewalPreferenceStore } from '../store/renewalPreferenceStore';

// Always fetches the latest renewal preference on mount and syncs it into the shared store, so
// every mounted consumer (Payment Section, Renewal Options) reflects the same value without a
// full page reload.
export function useRenewalPreference() {
  const { renewalPreference, setRenewalPreference } = useRenewalPreferenceStore();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errorCode, setErrorCode] = useState(null);

  const refetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    setErrorCode(null);
    try {
      const res = await billingApi.getAutoRenewal();
      if (res?.success) setRenewalPreference(res.data);
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Failed to load renewal preference.');
      setErrorCode(err?.response?.data?.errorCode ?? null);
      // Don't leave a stale enabled/current preference on screen when we can't confirm it.
      setRenewalPreference({ enabled: false, paymentMethod: null });
    } finally {
      setLoading(false);
    }
  }, [setRenewalPreference]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { renewalPreference, loading, error, errorCode, refetch, setRenewalPreference };
}
